import React, { useState } from "react";
import { SwiperSlide } from "swiper/react";
import "swiper/modules/grid/grid.min.css";
import { Pagination, Navigation } from "swiper";

import { Icons } from "../../../assets/icons";
import { EMPTY_STRING } from "../../../constants";
import { isVideoUrl } from "../../../shared";
import IconButton from "../../../shared/components/IconButton/IconButton";
import SliderWrapper from "../../../shared/components/Slider/SliderWrapper";
import MediaPreviewModal from "../../../shared/components/Modal/MediaPreviewModal";

const { PlayIcon, ChevronLeftIcon, ChevronRightIcon } = Icons;

const ShutterBSliderMobileView = ({ profileData }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getGalleryItems = () => {
    const baseUrl = process.env.REACT_APP_S3_BASE_URL_PORTFOLIO;
    const galleries = profileData?.sbportfolios?.[0]?.gallery ?? [];

    return galleries.map((gallery) => ({
      ...gallery,
      url: gallery.imageUrl
        ? `${baseUrl}/${gallery.imageUrl}`
        : gallery.imageUrl,
      thumbnailUrl: gallery.imageThumbnailUrl
        ? `${baseUrl}/${gallery.imageThumbnailUrl}`
        : gallery.imageThumbnailUrl,
    }));
  };

  return (
    <>
      <div
        className="sutterb-image-slider-mobile"
        onClick={(e) => e.stopPropagation()}
      >
        {getGalleryItems()?.length > 0 > 0 && (
          <SliderWrapper
            spaceBetween={0}
            sliderHeight={"360px"}
            PrevIcon={ChevronLeftIcon}
            NextIcon={ChevronRightIcon}
            prevButtonClass="shutterb-swiper-button shutterb-swiper-button-prev-mobile"
            nextButtonClass="shutterb-swiper-button shutterb-swiper-button-next-mobile"
            showPagination
            modules={[Pagination, Navigation]}
          >
            {getGalleryItems().map((gallery, index) => {
              const imagePath =
                gallery.thumbnailUrl || gallery.url || EMPTY_STRING;
              return (
                <SwiperSlide key={index}>
                  <div className="video-thumbnail-wrapper h-100 w-100">
                    <img
                      className="h-100 w-100"
                      src={imagePath}
                      alt={`p-${index}`}
                      onClick={() => {
                        setCurrentIndex(index);
                        setIsModalOpen(true);
                      }}
                    />
                    {isVideoUrl(gallery.imageUrl) && (
                      <div className="play-icon-overlay">
                        <IconButton
                          icon={<PlayIcon />}
                          width="35px"
                          height="35px"
                          className="shutterb-profile-play-icon"
                          handleClick={() => {
                            setCurrentIndex(index);
                            setIsModalOpen(true);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </SwiperSlide>
              );
            })}
          </SliderWrapper>
        )}
      </div>

      <MediaPreviewModal
        isOpen={isModalOpen}
        currentIndex={currentIndex}
        mediaFiles={getGalleryItems()}
        setCurrentIndex={setCurrentIndex}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default ShutterBSliderMobileView;